/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react'
import {useLocalStorage} from "./use_local_storage";

type Options = {
  persistFalsyValues: boolean
}

export const usePersistedState = <T>(
  key: string,
  initialValue: T,
  options: Options = { persistFalsyValues: true },
): [value: T, setter: React.Dispatch<React.SetStateAction<T>>] => {
  const ls = useLocalStorage()

  /*
    State is initialised in the setter here rather than in a useEffect to ensure
    that initial state is synchronised properly with local storage. This solution is
    appropriate for CSR scenarios, but not for SSR.
    The previous solution initialised state in a useEffect, which works well in SSR because
    initial state will synchronoize correctly, but not in CSR scenarios
  */
  const [state, setState] = useState<T>(() => {
    const result: string | null = ls.getItem(key)
    if (result) {
      let parsed = result
      if (typeof parsed === 'string') {
        parsed = parsed.replace(/"/g, '')
      }
      return parsed
    } else {
      return initialValue
    }
  })

  useEffect(() => {
    const { persistFalsyValues } = options
    if (state || persistFalsyValues) {
      ls.setItem(key, state)
    }
  }, [state])

  return [state, setState]
}
